/**
 * What the finish save sends for a message's parts (TX-5152).
 *
 * The browser's copy of an attachment is its `data:` preview — the bytes. The
 * save posts the whole live conversation, so a few photos put it past Vercel's
 * ~4.5 MB request cap and the save failed. The server already stored each
 * file when it was sent and puts its own file parts back on save, so a file
 * part goes without its bytes: its type and name stay, its `url` is emptied.
 */
export function withoutInlineFileBytes(parts: unknown): unknown {
  if (!Array.isArray(parts)) return parts;
  return parts.map((part) => {
    const p = part as { type?: unknown; url?: unknown; data?: unknown } | null;
    if (p?.type !== "file") return part;
    const { data: _data, ...rest } = p as Record<string, unknown>;
    return { ...rest, url: "" };
  });
}
